(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    'use strict';

    /* ---------- Textes fixes ---------- */
    var SIZE_USAGE_TEXT = {
      'Mini 28 cm': 'Pour les enfants ou en décoration',
      'Medium 35 cm': 'Pour table basse ou en bout de canapé',
      'Standard 42 cm': 'Pour table à manger ou en table de chevet',
      'Maxi 50 cm': 'Pour les plus grands ou pour table haute'
    };

    var COLOR_RAL_TEXT = {
      'Bleu de Paris': 'RAL 5002',
      'Rose Montmartre': 'RAL 3015',
      'Marron Garnier': 'RAL 8001',
      'Rouge Pigalle': 'RAL 3020',
      'Noir Haussmann': 'RAL 9004',
      'Orange St-Germain': 'RAL 2004',
      'Gris Eiffel': 'RAL 7040',
      'Jaune Bastille': 'RAL 1016',
      'Blanc Sacré-Cœur': 'RAL 9001',
      'Vert Tuilerie': 'RAL 6018',
      'Vert Concorde': 'RAL 6005'
    };

    var OFFER_IN_STOCK_SELECTOR = '[data-block-id="offer_c6dbC9"]';
    var OFFER_OUT_OF_STOCK_SELECTOR = '[data-block-id="offer_yzjkwH"]';

    var instances = {};
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ---------- Utilitaires ---------- */
    function parseJSON(value, fallback) {
      try {
        return value ? JSON.parse(value) : fallback;
      } catch (error) {
        return fallback;
      }
    }

    function getRoot(inst) {
      return document.getElementById(inst.rootId);
    }

    function labelFor(root, input) {
      if (!input.id) return null;
      return root.querySelector('label[for="' + input.id + '"]');
    }

    /* textContent ne force pas de calcul de mise en page, contrairement à innerText */
    function labelText(label) {
      if (!label) return '';
      var el = label.querySelector('.block-swatch__label') || label.querySelector('span');
      return el ? el.textContent.trim() : '';
    }

    function selectedOptionText(root, position) {
      var input = root.querySelector('input[data-option-position="' + position + '"]:checked');
      return input ? labelText(labelFor(root, input)) : null;
    }

    function setText(el, text) {
      if (el && el.textContent !== text) el.textContent = text;
    }

    /* ---------- Tailles disponibles selon la couleur ---------- */
    function filterSizes(inst, root) {
      /* Sécurité : sans données de variantes ou sans couleur cochée, on ne masque rien */
      if (!inst.variants.length) return;
      var color = selectedOptionText(root, 1);
      if (!color) return;

      root.querySelectorAll('input[data-option-position="2"]').forEach(function (input) {
        var label = labelFor(root, input);
        if (!label) return;

        var size = labelText(label);
        var valid = inst.variants.some(function (variant) {
          return variant.o1 === color && variant.o2 === size;
        });

        var display = valid ? '' : 'none';
        if (label.style.display !== display) label.style.display = display;
        if (!valid && input.checked) input.checked = false;
      });
    }

    /* ---------- Badge « Best-seller » ---------- */
    function addBestSellerBadge(root) {
      root.querySelectorAll('input[data-option-position="2"]').forEach(function (input) {
        var label = labelFor(root, input);
        if (!label || labelText(label) !== 'Standard 42 cm') return;
        if (label.querySelector('.block-swatch__badge')) return;

        var badge = document.createElement('span');
        badge.className = 'block-swatch__badge';
        badge.textContent = 'Best-seller';
        label.appendChild(badge);
      });
    }

    /* ---------- Usage selon la hauteur ---------- */
    function updateUsageText(root) {
      var container = root.querySelector('#size-usage-text');

      if (!container) {
        var sizeInput = root.querySelector('[data-option-position="2"]');
        var fieldset = sizeInput && sizeInput.closest('fieldset.variant-picker__option');
        var infoBlock = fieldset && fieldset.querySelector('.variant-picker__option-info');
        if (!infoBlock) return;

        container = document.createElement('div');
        container.id = 'size-usage-text';
        container.className = 'size-usage-text';
        infoBlock.insertAdjacentElement('afterend', container);
      }

      setText(container, SIZE_USAGE_TEXT[selectedOptionText(root, 2)] || '');
    }

    /* ---------- Référence RAL ---------- */
    function updateRalText(root) {
      var container = root.querySelector('#color-ral-text');

      if (!container) {
        var colorInput = root.querySelector('[data-option-position="1"]');
        var fieldset = colorInput && colorInput.closest('fieldset.variant-picker__option');
        var hStack = fieldset && fieldset.querySelector('.variant-picker__option-info .h-stack');
        if (!hStack) return;

        container = document.createElement('span');
        container.id = 'color-ral-text';
        container.className = 'color-ral-text';
        hStack.appendChild(container);
      }

      setText(container, COLOR_RAL_TEXT[selectedOptionText(root, 1)] || '');
    }

    /* ---------- Libellés des options ---------- */
    function renameLegends(root) {
      root.querySelectorAll('.variant-picker__option-info .text-subdued').forEach(function (legend) {
        var text = legend.textContent.trim();
        if (text.indexOf('Je choisis la couleur') === 0) {
          legend.textContent = 'Couleur :';
        } else if (text.indexOf('Je choisis la hauteur') === 0) {
          legend.textContent = 'Hauteur :';
        }
      });
    }

    /* ---------- Blocs d'offre en stock / rupture ---------- */
    function updateOffers(inst, root) {
      var inStock = root.querySelector(OFFER_IN_STOCK_SELECTOR);
      var outOfStock = root.querySelector(OFFER_OUT_OF_STOCK_SELECTOR);
      if (!inStock || !outOfStock) return;

      var form = document.getElementById(inst.formId);
      var field = form && form.querySelector('[name="id"]');
      if (!field || !field.value) return;

      var variant = inst.variantsById[String(field.value)];
      if (!variant) return;

      var suffix = outOfStock.querySelector('.offer__title-suffix');
      if (suffix) {
        var date = inst.restock[String(field.value)] || '';
        setText(suffix, date ? ' - ' + date : '');
      }

      if (inStock.hidden !== !variant.a) inStock.hidden = !variant.a;
      if (outOfStock.hidden !== variant.a) outOfStock.hidden = variant.a;
    }

    /* ---------- Mise à jour groupée ---------- */
    function updateAll(inst) {
      var root = getRoot(inst);
      if (!root) return;

      filterSizes(inst, root);
      addBestSellerBadge(root);

      if (inst.tabouret) {
        updateUsageText(root);
        updateRalText(root);
        renameLegends(root);
        updateOffers(inst, root);
      }
    }

    /* Une seule mise à jour par image, quel que soit le nombre de changements */
    function scheduleUpdate(inst) {
      if (inst.pending) return;
      inst.pending = true;
      requestAnimationFrame(function () {
        inst.pending = false;
        if (instances[inst.sectionId] === inst) updateAll(inst);
      });
    }

    /* Ignore les changements de la galerie (Nova, carrousel) et de la barre collante */
    function hasRelevantMutation(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var target = mutations[i].target;
        if (target.nodeType !== 1) target = target.parentElement;
        if (!target) continue;
        if (target.closest('product-gallery, .product-gallery, .sticky-cart-container, product-quick-add')) continue;
        return true;
      }
      return false;
    }

    /* ---------- Références RAL et mention HT (version SparkLayer) ---------- */
    function initSparkLayer() {
      var attached = false;
      var busy = false;
      var innerObserver = null;
      var watcher = null;
      var watcherTimer = null;
      var pdpRef = null;

      function getPdp() {
        var el = document.querySelector('spark-pdp');
        return el && el.shadowRoot ? el : null;
      }

      function addHtLabel(pdp) {
        var wrapper = pdp.shadowRoot.querySelector('.price-summary');
        if (!wrapper || pdp.shadowRoot.getElementById('ht-style')) return;

        var style = document.createElement('style');
        style.id = 'ht-style';
        style.textContent = '.price-summary{display:block!important;text-align:left!important}.price-summary::before{content:"Hors taxes";display:block;font-size:14px;font-weight:400;color:rgb(26 26 26/75%);margin-bottom:2px}.price-summary p{display:block!important}';
        pdp.shadowRoot.appendChild(style);
      }

      function updateText(pdp) {
        var select = pdp.shadowRoot.querySelector('.price-variants select, select');
        if (!select) return false;

        var box = pdp.shadowRoot.getElementById('spark-color-ral-text');
        if (!box) {
          var wrapper = select.closest('.input-field') || select.parentElement;
          if (!wrapper) return false;
          box = document.createElement('span');
          box.id = 'spark-color-ral-text';
          box.className = 'color-ral-text';
          wrapper.appendChild(box);
        }

        setText(box, COLOR_RAL_TEXT[select.value] || '');
        addHtLabel(pdp);
        return true;
      }

      function onShadowChange(event) {
        if (pdpRef && event.target.matches && event.target.matches('select')) updateText(pdpRef);
      }

      function attachOnce(pdp) {
        if (attached) return;
        attached = true;
        pdpRef = pdp;

        pdp.shadowRoot.addEventListener('change', onShadowChange);

        innerObserver = new MutationObserver(function () {
          if (busy) return;
          busy = true;
          requestAnimationFrame(function () {
            busy = false;
            updateText(pdp);
          });
        });
        innerObserver.observe(pdp.shadowRoot.querySelector('.price-variants') || pdp.shadowRoot, { childList: true, subtree: true });
      }

      function trySetup() {
        var pdp = getPdp();
        if (!pdp) return false;
        var found = updateText(pdp);
        attachOnce(pdp);
        return found;
      }

      function stopWatcher() {
        if (watcher) watcher.disconnect();
        watcher = null;
        clearTimeout(watcherTimer);
      }

      if (!document.querySelector('spark-pdp')) {
        return function () {};
      }

      if (!trySetup()) {
        var checking = false;
        watcher = new MutationObserver(function () {
          if (checking) return;
          checking = true;
          requestAnimationFrame(function () {
            checking = false;
            if (trySetup()) stopWatcher();
          });
        });
        watcher.observe(document.body, { childList: true, subtree: true });
        watcherTimer = setTimeout(stopWatcher, 20000);
      }

      return function cleanup() {
        stopWatcher();
        if (innerObserver) innerObserver.disconnect();
        if (pdpRef && pdpRef.shadowRoot) pdpRef.shadowRoot.removeEventListener('change', onShadowChange);
      };
    }

    /* ---------- Fenêtres du guide des tailles ---------- */
    function movePopupsToBody(sectionEl) {
      var moved = [];
      sectionEl.querySelectorAll('.product-color-popup__overlay').forEach(function (popup) {
        if (popup.id) {
          var previous = document.getElementById(popup.id);
          if (previous && previous !== popup && !sectionEl.contains(previous)) previous.remove();
        }
        document.body.appendChild(popup);
        moved.push(popup);
      });
      return moved;
    }

    /* ---------- Cycle de vie d'une section ---------- */
    function init(config) {
      var sectionId = config.dataset.sectionId;
      if (!sectionId) return;
      if (instances[sectionId]) destroy(sectionId);

      var sectionEl = document.getElementById('shopify-section-' + sectionId) || config.parentElement;
      var variants = parseJSON(config.dataset.variants, []);
      var variantsById = {};
      variants.forEach(function (variant) {
        variantsById[String(variant.id)] = variant;
      });

      var inst = {
        sectionId: sectionId,
        sectionEl: sectionEl,
        rootId: config.dataset.rootId,
        formId: config.dataset.formId,
        tabouret: config.dataset.tabouret === 'true',
        variants: variants,
        variantsById: variantsById,
        restock: parseJSON(config.dataset.restock, {}),
        pending: false,
        timers: []
      };
      instances[sectionId] = inst;

      inst.movedPopups = movePopupsToBody(sectionEl);

      inst.onChange = function (event) {
        var root = getRoot(inst);
        if (!root || !root.contains(event.target)) return;
        inst.timers.push(setTimeout(function () { scheduleUpdate(inst); }, 50));
      };
      sectionEl.addEventListener('change', inst.onChange);

      inst.onVariantChange = function () {
        scheduleUpdate(inst);
      };
      document.addEventListener('variant:change', inst.onVariantChange);

      inst.observer = new MutationObserver(function (mutations) {
        if (hasRelevantMutation(mutations)) scheduleUpdate(inst);
      });
      inst.observer.observe(sectionEl, { childList: true, subtree: true });

      inst.sparkCleanup = inst.tabouret ? initSparkLayer() : function () {};

      updateAll(inst);
      inst.timers.push(setTimeout(function () { scheduleUpdate(inst); }, 300));
    }

    function destroy(sectionId) {
      var inst = instances[sectionId];
      if (!inst) return;

      if (inst.observer) inst.observer.disconnect();
      inst.sectionEl.removeEventListener('change', inst.onChange);
      document.removeEventListener('variant:change', inst.onVariantChange);
      inst.timers.forEach(clearTimeout);
      inst.sparkCleanup();
      inst.movedPopups.forEach(function (popup) { popup.remove(); });

      delete instances[sectionId];
    }

    function initWithin(scope) {
      scope.querySelectorAll('[data-stooly-pdp]').forEach(init);
    }

    /* ---------- Écouteurs globaux (une seule fois par page) ---------- */

    /* Ajout au panier des produits complémentaires (auparavant déclaré deux fois) */
    document.addEventListener('submit', function (event) {
      var form = event.target.closest ? event.target.closest('.custom-variant-form') : null;
      if (!form) return;
      /* Uniquement sur les pages qui contiennent cette section, comme avant */
      if (!document.querySelector('[data-stooly-pdp]')) return;

      event.preventDefault();

      var button = form.querySelector('button');
      var field = form.querySelector('[name="id"]');
      if (!field) return;
      if (button) button.setAttribute('aria-busy', 'true');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: field.value, quantity: 1 })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Ajout au panier impossible');
          return response.json();
        })
        .then(function () {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          var cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) cartDrawer.setAttribute('open', '');
        })
        .catch(function (error) {
          console.error(error);
        })
        .finally(function () {
          if (button) button.removeAttribute('aria-busy');
        });
    });

    /* Mobile : remonte en haut de page après un changement de couleur */
    document.addEventListener('change', function (event) {
      var target = event.target;
      if (!target.matches || !target.matches('[data-option-position="1"]')) return;
      if (!target.closest('[id^="product-info-"]')) return;
      if (window.innerWidth > 768) return;

      window.scrollTo({ top: 0, behavior: reducedMotion ? 'auto' : 'smooth' });
    });

    /* Ouverture et fermeture du guide des tailles */
    document.addEventListener('click', function (event) {
      var button = event.target.closest('.product-color-popup__btn');
      if (button) {
        var popup = document.getElementById(button.getAttribute('data-popup'));
        if (popup) popup.classList.add('is-open');
      }

      if (event.target.closest('.product-color-popup__close')) {
        var openPopup = event.target.closest('.product-color-popup__overlay');
        if (openPopup) openPopup.classList.remove('is-open');
      }

      if (event.target.classList.contains('product-color-popup__overlay')) {
        event.target.classList.remove('is-open');
      }
    });

    /* Éditeur de thème : section ajoutée, déplacée ou modifiée */
    document.addEventListener('shopify:section:load', function (event) {
      initWithin(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      if (event.detail && event.detail.sectionId) destroy(event.detail.sectionId);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initWithin(document); });
    } else {
      initWithin(document);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stooly-avis-clients"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('stooly-reviews')) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    class StoolyReviews extends HTMLElement {
      connectedCallback() {
        this.baseLayout = this.dataset.layout || 'grid';
        this.mobileQuery = window.matchMedia('(max-width: 699px)');
        this.allowMobileCarousel = this.dataset.mobileCarousel === 'true' && this.baseLayout !== 'carousel';
        this.onMediaChange = () => {
          this.teardown();
          this.setup();
        };
        if (this.allowMobileCarousel) this.mobileQuery.addEventListener('change', this.onMediaChange);
        this.setup();
      }

      disconnectedCallback() {
        if (this.allowMobileCarousel && this.mobileQuery) {
          this.mobileQuery.removeEventListener('change', this.onMediaChange);
        }
        this.teardown();
      }

      setup() {
        this.cleanups = [];
        this.mobileOverride = this.allowMobileCarousel && this.mobileQuery.matches;
        this.layout = this.mobileOverride ? 'carousel' : this.baseLayout;
        this.viewport = this.querySelector('[data-viewport]');
        this.track = this.querySelector('[data-track]');
        this.controls = this.querySelector(this.mobileOverride ? '[data-mobile-controls]' : '[data-controls]');
        this.toggle = this.mobileOverride ? null : this.querySelector('[data-toggle]');
        this.state = { user: false, hover: false, focus: false, offscreen: false, editor: false, hidden: false };
        this.timer = null;
        this.items = null;

        if (!this.track) return;

        if (this.mobileOverride && this.viewport) {
          const viewport = this.viewport;
          viewport.setAttribute('role', 'group');
          viewport.setAttribute('aria-roledescription', 'carrousel');
          viewport.setAttribute('aria-label', 'Avis clients');
          viewport.setAttribute('tabindex', '0');
          this.cleanups.push(() => {
            ['role', 'aria-roledescription', 'aria-label', 'tabindex'].forEach((name) => viewport.removeAttribute(name));
          });
        }

        this.initReadMore();
        if (this.layout === 'carousel') this.initCarousel();
        if (this.layout === 'marquee') this.initMarquee();
        this.initEditor();
      }

      teardown() {
        this.stopAutoplay();
        (this.cleanups || []).forEach((fn) => fn());
        this.cleanups = [];
        if (this.track) this.track.querySelectorAll('[data-clone]').forEach((el) => el.remove());
        this.classList.remove('is-marquee-ready', 'is-paused', 'is-offscreen', 'is-editor-paused');
        this.querySelectorAll('[data-controls], [data-mobile-controls]').forEach((el) => { el.hidden = true; });
        this.querySelectorAll('[data-dots]').forEach((el) => { el.innerHTML = ''; });
        if (this.viewport) this.viewport.removeAttribute('aria-live');
      }

      on(target, type, handler, options) {
        target.addEventListener(type, handler, options);
        this.cleanups.push(() => target.removeEventListener(type, handler, options));
      }

      /* ---------- Lire la suite ---------- */
      initReadMore() {
        const texts = Array.from(this.querySelectorAll('[data-review-text]'));
        if (!texts.length) return;

        const check = () => {
          texts.forEach((text) => {
            const button = text.nextElementSibling;
            if (!button || !button.matches('[data-read-more]')) return;
            if (text.classList.contains('is-expanded')) return;
            button.hidden = !(text.scrollHeight > text.clientHeight + 1);
          });
        };

        check();

        if ('ResizeObserver' in window) {
          const observer = new ResizeObserver(() => check());
          texts.forEach((text) => observer.observe(text));
          this.cleanups.push(() => observer.disconnect());
        }

        this.on(this, 'click', (event) => {
          const button = event.target.closest('[data-read-more]');
          if (!button || !this.contains(button)) return;
          const text = button.previousElementSibling;
          if (!text) return;
          const expanded = button.getAttribute('aria-expanded') === 'true';
          button.setAttribute('aria-expanded', String(!expanded));
          text.classList.toggle('is-expanded', !expanded);
          button.textContent = expanded ? button.dataset.labelMore : button.dataset.labelLess;
        });
      }

      /* ---------- Carrousel ---------- */
      initCarousel() {
        this.items = Array.from(this.track.querySelectorAll('[data-item]'));
        this.prevButton = this.querySelector('[data-prev]');
        this.nextButton = this.querySelector('[data-next]');
        this.dotsContainer = this.controls ? this.controls.querySelector('[data-dots]') : null;
        this.positions = [];

        if (this.controls) this.controls.hidden = false;

        if (this.prevButton) this.on(this.prevButton, 'click', () => { this.goTo(this.activeIndex() - 1); this.restartAutoplay(); });
        if (this.nextButton) this.on(this.nextButton, 'click', () => { this.goTo(this.activeIndex() + 1); this.restartAutoplay(); });

        let frame = null;
        this.on(this.viewport, 'scroll', () => {
          if (frame) return;
          frame = requestAnimationFrame(() => { frame = null; this.updateUI(); });
        }, { passive: true });

        this.on(this.viewport, 'keydown', (event) => {
          if (event.target !== this.viewport) return;
          const keys = { ArrowRight: 1, ArrowLeft: -1 };
          if (event.key in keys) {
            event.preventDefault();
            this.goTo(this.activeIndex() + keys[event.key]);
          } else if (event.key === 'Home') {
            event.preventDefault();
            this.goTo(0);
          } else if (event.key === 'End') {
            event.preventDefault();
            this.goTo(this.positions.length - 1);
          }
        });

        if ('ResizeObserver' in window) {
          const observer = new ResizeObserver(() => this.computePositions());
          observer.observe(this.viewport);
          this.cleanups.push(() => observer.disconnect());
        } else {
          this.on(window, 'resize', () => this.computePositions());
        }

        this.computePositions();
        this.initAutoplay();
      }

      computePositions() {
        const padding = parseFloat(getComputedStyle(this.viewport).paddingLeft) || 0;
        const max = this.viewport.scrollWidth - this.viewport.clientWidth;
        const positions = [];

        this.items.forEach((item) => {
          const target = Math.max(0, Math.min(item.offsetLeft - padding, max));
          if (!positions.length || Math.abs(target - positions[positions.length - 1]) > 2) positions.push(target);
        });

        const changed = positions.length !== this.positions.length;
        this.positions = positions;
        if (changed) this.buildDots();
        if (this.controls) this.controls.hidden = this.positions.length <= 1;
        this.updateUI();
      }

      buildDots() {
        if (!this.dotsContainer) return;
        this.dotsContainer.innerHTML = '';
        const template = this.dataset.labelDot || '[n] / [total]';
        this.positions.forEach((_, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'stooly-reviews__dot';
          dot.setAttribute('aria-label', template.replace('[n]', index + 1).replace('[total]', this.positions.length));
          dot.addEventListener('click', () => { this.goTo(index); this.restartAutoplay(); });
          this.dotsContainer.appendChild(dot);
        });
      }

      activeIndex() {
        const left = this.viewport.scrollLeft;
        let best = 0;
        let min = Infinity;
        this.positions.forEach((position, index) => {
          const distance = Math.abs(position - left);
          if (distance < min) { min = distance; best = index; }
        });
        return best;
      }

      goTo(index) {
        if (!this.positions.length) return;
        const clamped = Math.max(0, Math.min(index, this.positions.length - 1));
        this.viewport.scrollTo({ left: this.positions[clamped], behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      }

      updateUI() {
        if (!this.positions || !this.positions.length) return;
        const active = this.activeIndex();
        if (this.prevButton) this.prevButton.disabled = active === 0;
        if (this.nextButton) this.nextButton.disabled = active === this.positions.length - 1;
        if (this.dotsContainer) {
          Array.from(this.dotsContainer.children).forEach((dot, index) => {
            dot.setAttribute('aria-current', index === active ? 'true' : 'false');
          });
        }
      }

      /* ---------- Lecture automatique (carrousel) ---------- */
      initAutoplay() {
        this.autoplayEnabled = this.dataset.autoplay === 'true';
        if (!this.autoplayEnabled) {
          this.viewport.setAttribute('aria-live', 'polite');
          return;
        }

        this.delay = parseInt(this.dataset.autoplaySpeed, 10) || 6000;
        this.bindPauseTriggers();

        this.on(reducedMotion, 'change', () => this.syncAutoplay());
        this.syncAutoplay();
      }

      bindPauseTriggers() {
        if (this.toggle) {
          this.toggle.hidden = false;
          this.on(this.toggle, 'click', () => {
            this.state.user = !this.state.user;
            this.syncAutoplay();
          });
        }

        this.on(this, 'mouseenter', () => { this.state.hover = true; this.syncAutoplay(); });
        this.on(this, 'mouseleave', () => { this.state.hover = false; this.syncAutoplay(); });
        this.on(this, 'focusin', () => { this.state.focus = true; this.syncAutoplay(); });
        this.on(this, 'focusout', (event) => {
          if (!this.contains(event.relatedTarget)) { this.state.focus = false; this.syncAutoplay(); }
        });
        this.on(document, 'visibilitychange', () => { this.state.hidden = document.hidden; this.syncAutoplay(); });

        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => { this.state.offscreen = !entry.isIntersecting; this.syncAutoplay(); });
          });
          observer.observe(this);
          this.cleanups.push(() => observer.disconnect());
        }
      }

      updateToggle(running) {
        if (!this.toggle) return;
        const paused = this.state.user;
        this.toggle.setAttribute('aria-label', paused ? this.dataset.labelPlay : this.dataset.labelPause);
        const pauseIcon = this.toggle.querySelector('[data-icon-pause]');
        const playIcon = this.toggle.querySelector('[data-icon-play]');
        if (pauseIcon) pauseIcon.hidden = paused;
        if (playIcon) playIcon.hidden = !paused;
        if (this.layout === 'carousel' && this.viewport) {
          this.viewport.setAttribute('aria-live', running ? 'off' : 'polite');
        }
      }

      syncAutoplay() {
        if (this.layout === 'marquee') {
          this.classList.toggle('is-paused', this.state.user);
          this.classList.toggle('is-offscreen', this.state.offscreen || this.state.hidden);
          this.classList.toggle('is-editor-paused', this.state.editor);
          this.updateToggle(false);
          return;
        }

        if (reducedMotion.matches) {
          if (this.toggle) this.toggle.hidden = true;
          this.stopAutoplay();
          this.updateToggle(false);
          return;
        }

        if (this.toggle) this.toggle.hidden = false;
        const s = this.state;
        const shouldRun = !(s.user || s.hover || s.focus || s.offscreen || s.editor || s.hidden);
        if (shouldRun) this.startAutoplay(); else this.stopAutoplay();
        this.updateToggle(shouldRun);
      }

      startAutoplay() {
        if (this.timer) return;
        this.timer = window.setInterval(() => {
          const next = this.activeIndex() + 1;
          this.goTo(next >= this.positions.length ? 0 : next);
        }, this.delay);
      }

      stopAutoplay() {
        if (this.timer) {
          window.clearInterval(this.timer);
          this.timer = null;
        }
      }

      restartAutoplay() {
        if (!this.timer) return;
        this.stopAutoplay();
        this.startAutoplay();
      }

      /* ---------- Défilement continu ---------- */
      initMarquee() {
        if (reducedMotion.matches) return;

        const items = Array.from(this.track.children);
        if (!items.length) return;

        items.forEach((item) => {
          const clone = item.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.setAttribute('inert', '');
          clone.setAttribute('data-clone', '');
          clone.removeAttribute('data-shopify-editor-block');
          clone.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
          clone.querySelectorAll('[aria-controls]').forEach((el) => el.removeAttribute('aria-controls'));
          clone.querySelectorAll('a, button').forEach((el) => el.setAttribute('tabindex', '-1'));
          this.track.appendChild(clone);
        });

        this.classList.add('is-marquee-ready');
        if (this.controls) this.controls.hidden = false;

        if (this.toggle) {
          this.on(this.toggle, 'click', () => {
            this.state.user = !this.state.user;
            this.syncAutoplay();
          });
        }

        this.on(document, 'visibilitychange', () => { this.state.hidden = document.hidden; this.syncAutoplay(); });

        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => { this.state.offscreen = !entry.isIntersecting; this.syncAutoplay(); });
          });
          observer.observe(this);
          this.cleanups.push(() => observer.disconnect());
        }

        this.syncAutoplay();
      }

      /* ---------- Éditeur de thème ---------- */
      initEditor() {
        if (!window.Shopify || !window.Shopify.designMode) return;

        this.on(document, 'shopify:block:select', (event) => {
          const block = event.target;
          if (!(block instanceof Element) || !this.contains(block)) return;
          this.state.editor = true;

          if (this.layout === 'carousel' && this.items) {
            const item = block.closest('[data-item]');
            const padding = parseFloat(getComputedStyle(this.viewport).paddingLeft) || 0;
            if (item) {
              const target = item.offsetLeft - padding;
              let best = 0;
              let min = Infinity;
              this.positions.forEach((position, index) => {
                const distance = Math.abs(position - target);
                if (distance < min) { min = distance; best = index; }
              });
              this.goTo(best);
            }
          }

          this.syncAutoplay();
        });

        this.on(document, 'shopify:block:deselect', (event) => {
          if (!(event.target instanceof Element) || !this.contains(event.target)) return;
          this.state.editor = false;
          this.syncAutoplay();
        });
      }
    }

    customElements.define('stooly-reviews', StoolyReviews);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stooly-categories"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('stooly-categories')) return;

    class StoolyCategories extends HTMLElement {
      connectedCallback() {
        this.rail = this.querySelector('[data-stooly-rail]');
        if (!this.rail) return;

        this.items = Array.prototype.slice.call(this.rail.querySelectorAll('[data-stooly-item]'));
        this.controls = this.querySelector('[data-stooly-controls]');
        this.prevButton = this.querySelector('[data-stooly-prev]');
        this.nextButton = this.querySelector('[data-stooly-next]');
        this.track = this.querySelector('[data-stooly-track]');
        this.thumb = this.querySelector('[data-stooly-thumb]');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.frame = 0;
        this.scrub = null;

        this.onScroll = this.onScroll.bind(this);
        this.onPrev = this.onPrev.bind(this);
        this.onNext = this.onNext.bind(this);
        this.onTrackDown = this.onTrackDown.bind(this);
        this.onTrackMove = this.onTrackMove.bind(this);
        this.onTrackUp = this.onTrackUp.bind(this);
        this.onBlockSelect = this.onBlockSelect.bind(this);

        this.rail.addEventListener('scroll', this.onScroll, { passive: true });
        if (this.prevButton) this.prevButton.addEventListener('click', this.onPrev);
        if (this.nextButton) this.nextButton.addEventListener('click', this.onNext);
        if (this.track) this.track.addEventListener('pointerdown', this.onTrackDown);
        this.addEventListener('shopify:block:select', this.onBlockSelect);

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.onScroll);
          this.resizeObserver.observe(this.rail);
        } else {
          window.addEventListener('resize', this.onScroll);
        }

        this.update();
      }

      disconnectedCallback() {
        if (!this.rail) return;
        this.rail.removeEventListener('scroll', this.onScroll);
        if (this.prevButton) this.prevButton.removeEventListener('click', this.onPrev);
        if (this.nextButton) this.nextButton.removeEventListener('click', this.onNext);
        if (this.track) this.track.removeEventListener('pointerdown', this.onTrackDown);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        window.removeEventListener('resize', this.onScroll);
        this.stopScrub();
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
      }

      get maxScroll() {
        return Math.max(0, this.rail.scrollWidth - this.rail.clientWidth);
      }

      get behavior() {
        return this.reducedMotion.matches ? 'auto' : 'smooth';
      }

      paddings() {
        var styles = window.getComputedStyle(this.rail);
        return {
          start: parseFloat(styles.paddingLeft) || 0,
          end: parseFloat(styles.paddingRight) || 0
        };
      }

      // Position de défilement qui aligne chaque carte sur le bord gauche du rail
      positions() {
        var pad = this.paddings().start;
        var max = this.maxScroll;
        return this.items.map(function (item) {
          return Math.max(0, Math.min(max, item.offsetLeft - pad));
        });
      }

      scrollToX(x) {
        this.rail.scrollTo({ left: Math.max(0, Math.min(this.maxScroll, x)), behavior: this.behavior });
      }

      // Suivant : la première carte coupée à droite devient la première carte visible
      onNext() {
        if (this.nextButton.getAttribute('aria-disabled') === 'true') return;
        var pads = this.paddings();
        var x = this.rail.scrollLeft;
        var visibleEnd = x + this.rail.clientWidth - pads.start - pads.end;
        var positions = this.positions();
        var target = this.maxScroll;

        for (var i = 0; i < this.items.length; i++) {
          var itemEnd = positions[i] + this.items[i].offsetWidth;
          if (positions[i] > x + 2 && itemEnd > visibleEnd + 2) {
            target = positions[i];
            break;
          }
        }
        this.scrollToX(target);
      }

      // Précédent : recule d’un écran de cartes, sans dépasser le début
      onPrev() {
        if (this.prevButton.getAttribute('aria-disabled') === 'true') return;
        var pads = this.paddings();
        var x = this.rail.scrollLeft;
        var width = this.rail.clientWidth - pads.start - pads.end;
        var positions = this.positions();
        var target = 0;

        for (var i = 0; i < positions.length; i++) {
          if (positions[i] >= x - width - 2 && positions[i] < x - 2) {
            target = positions[i];
            break;
          }
        }
        this.scrollToX(target);
      }

      /* Barre de progression : clic pour aller à un endroit, glisser pour parcourir */
      onTrackDown(event) {
        if (event.button !== 0 || !this.thumb) return;
        var max = this.maxScroll;
        if (max <= 1) return;
        event.preventDefault();

        var trackRect = this.track.getBoundingClientRect();
        var thumbRect = this.thumb.getBoundingClientRect();
        var free = trackRect.width - thumbRect.width;
        if (free <= 0) return;

        if (event.target !== this.thumb) {
          // Centre la poignée sous le pointeur, puis continue en mode glisser
          var left = event.clientX - trackRect.left - thumbRect.width / 2;
          var ratio = Math.max(0, Math.min(1, left / free));
          this.rail.scrollLeft = ratio * max;
        }

        this.scrub = {
          pointerId: event.pointerId,
          startX: event.clientX,
          startScroll: this.rail.scrollLeft,
          scale: max / free
        };
        this.classList.add('is-scrubbing');
        try { this.track.setPointerCapture(event.pointerId); } catch (e) {}
        this.track.addEventListener('pointermove', this.onTrackMove);
        this.track.addEventListener('pointerup', this.onTrackUp);
        this.track.addEventListener('pointercancel', this.onTrackUp);
      }

      onTrackMove(event) {
        if (!this.scrub) return;
        this.rail.scrollLeft = this.scrub.startScroll + (event.clientX - this.scrub.startX) * this.scrub.scale;
      }

      onTrackUp() {
        var wasScrubbing = !!this.scrub;
        this.stopScrub();
        if (!wasScrubbing) return;

        // Termine proprement sur le bord de la carte la plus proche
        var x = this.rail.scrollLeft;
        var positions = this.positions();
        var closest = positions.reduce(function (best, p) {
          return Math.abs(p - x) < Math.abs(best - x) ? p : best;
        }, 0);
        if (x >= this.maxScroll - 1) closest = this.maxScroll;
        this.scrollToX(closest);
      }

      stopScrub() {
        if (this.track) {
          if (this.scrub) {
            try { this.track.releasePointerCapture(this.scrub.pointerId); } catch (e) {}
          }
          this.track.removeEventListener('pointermove', this.onTrackMove);
          this.track.removeEventListener('pointerup', this.onTrackUp);
          this.track.removeEventListener('pointercancel', this.onTrackUp);
        }
        this.scrub = null;
        this.classList.remove('is-scrubbing');
      }

      onBlockSelect(event) {
        var item = event.target.closest ? event.target.closest('[data-stooly-item]') : null;
        var index = this.items.indexOf(item);
        if (index === -1) return;
        this.rail.scrollTo({ left: this.positions()[index], behavior: 'auto' });
      }

      onScroll() {
        if (this.frame) return;
        var self = this;
        this.frame = requestAnimationFrame(function () {
          self.frame = 0;
          self.update();
        });
      }

      update() {
        var max = this.maxScroll;
        var hasOverflow = max > 1;
        var x = this.rail.scrollLeft;

        if (this.controls) this.controls.hidden = !hasOverflow;
        this.classList.toggle('has-more-right', hasOverflow && x < max - 1);
        if (!hasOverflow) return;

        var atStart = x <= 1;
        var atEnd = x >= max - 1;
        if (this.prevButton) this.prevButton.setAttribute('aria-disabled', atStart ? 'true' : 'false');
        if (this.nextButton) this.nextButton.setAttribute('aria-disabled', atEnd ? 'true' : 'false');

        if (this.thumb) {
          // Taille de la poignée = part visible ; position = avancement réel du défilement
          var visible = Math.max(0.12, Math.min(1, this.rail.clientWidth / this.rail.scrollWidth));
          var progress = atEnd ? 1 : Math.max(0, Math.min(1, x / max));
          this.thumb.style.width = (visible * 100) + '%';
          this.thumb.style.transform = 'translateX(' + (progress * (1 / visible - 1) * 100) + '%)';
        }
      }
    }

    customElements.define('stooly-categories', StoolyCategories);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stooly-columns"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('flex-columns')) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    class FlexColumns extends HTMLElement {
      constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
        this.handleBlockSelect = this.handleBlockSelect.bind(this);
        this.handleVideoPause = this.handleVideoPause.bind(this);
        this.handleVideoPlay = this.handleVideoPlay.bind(this);
        this.syncAllVideos = this.syncAllVideos.bind(this);
        this.updateScrollableState = this.updateScrollableState.bind(this);
      }

      /* Appelé aussi quand l'éditeur ajoute, recharge ou déplace la section */
      connectedCallback() {
        this.grid = this.querySelector('[data-flex-columns-grid]');
        this.addEventListener('click', this.handleClick);
        document.addEventListener('shopify:block:select', this.handleBlockSelect);
        reducedMotion.addEventListener('change', this.syncAllVideos);

        if (this.grid && 'ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.updateScrollableState);
          this.resizeObserver.observe(this.grid);
        }

        this.updateScrollableState();
        this.setupAutoplayVideos();
      }

      /* Appelé quand l'éditeur supprime ou recharge la section */
      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
        reducedMotion.removeEventListener('change', this.syncAllVideos);
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.videoObserver) this.videoObserver.disconnect();
        (this.autoplayVideos || []).forEach((video) => {
          video.removeEventListener('pause', this.handleVideoPause);
          video.removeEventListener('play', this.handleVideoPlay);
        });
      }

      /* Le défilement horizontal mobile devient une région focusable au clavier */
      updateScrollableState() {
        if (!this.grid) return;
        const scrollable = this.grid.scrollWidth - this.grid.clientWidth > 1;

        if (scrollable) {
          this.grid.setAttribute('tabindex', '0');
          this.grid.setAttribute('role', 'region');
          this.grid.setAttribute('aria-label', this.grid.dataset.label || 'Colonnes');
        } else {
          this.grid.removeAttribute('tabindex');
          this.grid.removeAttribute('role');
          this.grid.removeAttribute('aria-label');
        }
      }

      /* Vidéo YouTube / Vimeo : l'iframe n'est chargée qu'au clic */
      handleClick(event) {
        const facade = event.target.closest('[data-video-facade]');
        if (!facade || !this.contains(facade) || !facade.dataset.src) return;

        const iframe = document.createElement('iframe');
        iframe.src = facade.dataset.src;
        iframe.title = facade.dataset.title || 'Vidéo';
        iframe.className = 'flex-columns__iframe';
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        iframe.allowFullscreen = true;
        facade.replaceWith(iframe);
        iframe.focus();
      }

      /* Vidéos Shopify en lecture automatique : visibles, sans réduction des animations, non mises en pause par l'utilisateur */
      setupAutoplayVideos() {
        this.autoplayVideos = Array.from(this.querySelectorAll('[data-autoplay-video] video'));
        if (!this.autoplayVideos.length) return;

        this.autoplayVideos.forEach((video) => {
          video.addEventListener('pause', this.handleVideoPause);
          video.addEventListener('play', this.handleVideoPlay);
        });

        if ('IntersectionObserver' in window) {
          this.videoObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              entry.target.dataset.inView = entry.isIntersecting ? 'true' : 'false';
              this.syncVideo(entry.target);
            });
          }, { threshold: 0.25 });

          this.autoplayVideos.forEach((video) => this.videoObserver.observe(video));
        } else {
          this.autoplayVideos.forEach((video) => {
            video.dataset.inView = 'true';
            this.syncVideo(video);
          });
        }
      }

      syncAllVideos() {
        (this.autoplayVideos || []).forEach((video) => this.syncVideo(video));
      }

      syncVideo(video) {
        const shouldPlay = !reducedMotion.matches && video.dataset.inView === 'true' && video.dataset.userPaused !== 'true';

        if (!shouldPlay) {
          if (!video.paused) {
            video.dataset.autoPaused = 'true';
            video.pause();
          }
          return;
        }

        video.muted = true;
        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(() => {});
      }

      handleVideoPause(event) {
        const video = event.currentTarget;
        if (video.dataset.autoPaused === 'true') {
          delete video.dataset.autoPaused;
        } else {
          video.dataset.userPaused = 'true';
        }
      }

      handleVideoPlay(event) {
        delete event.currentTarget.dataset.userPaused;
      }

      /* Éditeur : amène la colonne du bloc sélectionné dans la zone visible (mode défilement) */
      handleBlockSelect(event) {
        const target = event.target;
        if (!(target instanceof Element) || !this.contains(target) || !this.grid) return;
        if (this.grid.scrollWidth - this.grid.clientWidth <= 1) return;

        const column = target.closest('.flex-columns__column');
        if (!column) return;

        const left = this.grid.scrollLeft + column.getBoundingClientRect().left - this.grid.getBoundingClientRect().left;
        this.grid.scrollTo({ left, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      }
    }

    customElements.define('flex-columns', FlexColumns);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stooly-contact"] && !Shopify.designMode) return;
  try {
    
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduce = matchMedia('(prefers-reduced-motion:reduce)').matches;

  const goTo = (id, focusId) => {
    const section = document.getElementById(id);
    if (!section) return;
    /* On arrive au niveau du titre (ou du petit texte juste au-dessus), pas au bord de la section.
       Exception : un bloc peut désigner son propre point d'arrivée (data-st-scroll-to), par ex. le haut
       du bloc revendeur, pour que la photo soit visible en entier. */
    const head = document.getElementById(focusId);
    const prev = head?.previousElementSibling;
    const anchor = $('[data-st-scroll-to]', section);
    const target = anchor || (prev?.classList.contains('st-kicker') ? prev : (head || section));
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    head?.focus({ preventScroll: true });
  };

  /* Barre mobile : l'entrée active suit la section qui croise la ligne à 40 % de l'écran.
     Si cette ligne est sur une zone sans lien dans la barre (contacts en haut, bloc revendeur…),
     aucune entrée n'est surlignée. */
  function initBar(root) {
    const bar = $('[data-st-bar]', root);
    if (!bar) return;
    const links = $$('a', bar).filter(a => {
      const ok = document.getElementById(a.dataset.stSpy);
      a.hidden = !ok;
      return ok;
    });
    if (!links.length) { bar.hidden = true; return; }
    /* L'ordre de la barre suit l'ordre des blocs sur la page */
    links.sort((a, b) => (document.getElementById(a.dataset.stSpy).compareDocumentPosition(document.getElementById(b.dataset.stSpy)) & Node.DOCUMENT_POSITION_FOLLOWING) ? -1 : 1);
    links.forEach(a => bar.append(a));
    let locked = false, timer, frame = 0;
    const setCur = a => links.forEach(l => l.setAttribute('aria-current', String(l === a)));
    const update = () => {
      frame = 0;
      if (locked) return;
      const line = innerHeight * 0.4;
      const hit = links.find(l => {
        const r = document.getElementById(l.dataset.stSpy).getBoundingClientRect();
        return r.top <= line && r.bottom > line;
      });
      setCur(hit || null);
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    addEventListener('scroll', schedule, { passive: true });
    addEventListener('resize', schedule, { passive: true });
    /* Pendant le défilement déclenché par un clic, on garde l'entrée cliquée allumée,
       puis on recalcule une fois arrivé (fin du défilement, ou au plus tard après 1,5 s) */
    const unlock = () => { clearTimeout(timer); locked = false; schedule(); };
    links.forEach(a => {
      a.addEventListener('click', e => {
        e.preventDefault();
        locked = true; setCur(a);
        goTo(a.getAttribute('href').slice(1), a.dataset.stGoto);
        clearTimeout(timer);
        timer = setTimeout(unlock, 1500);
        if ('onscrollend' in window) addEventListener('scrollend', unlock, { once: true });
      });
    });
    update();
  }

  /* Carte : chargée un peu avant d'arriver dessus (environ 1 écran avant), jamais au démarrage de la page */
  function initMap(root) {
    $$('.st-map', root).forEach(box => {
      const tpl = $('template[data-st-embed]', box);
      if (!tpl) return;
      const load = () => {
        box.append(tpl.content.cloneNode(true));
        const fr = $('iframe', box);
        if (!fr) { box.classList.add('st-ready'); return; }
        fr.addEventListener('load', () => box.classList.add('st-ready'), { once: true });
        setTimeout(() => box.classList.add('st-ready'), 6000); /* au cas où l'événement n'arrive jamais */
      };
      if (!('IntersectionObserver' in window) || (window.Shopify && Shopify.designMode)) { load(); return; }
      const io = new IntersectionObserver(entries => {
        if (!entries.some(e => e.isIntersecting)) return;
        io.disconnect();
        load();
      }, { rootMargin: '100% 0px' });
      io.observe(box);
    });
  }

  /* Apparition au défilement : une seule fois, uniquement pour ce qui est sous la ligne de flottaison */
  function initReveal(root) {
    if (reduce || !('IntersectionObserver' in window)) return;
    const targets = $$('.st-cards:not([hidden]) > .st-card, .st-shop, .st-fold, .st-reseller', root)
      .filter(el => el.getBoundingClientRect().top > innerHeight * 0.92);
    if (!targets.length) return;
    const io = new IntersectionObserver(entries => {
      entries.filter(e => e.isIntersecting).forEach((e, i) => {
        const el = e.target;
        io.unobserve(el);
        el.style.setProperty('--d', i * 60 + 'ms');
        el.classList.add('st-in');
        const done = () => { el.classList.remove('st-pre', 'st-in'); el.style.removeProperty('--d'); };
        el.addEventListener('transitionend', ev => { if (ev.target === el && ev.propertyName === 'transform') done(); }, { once: false });
        setTimeout(done, 700 + i * 60);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    targets.forEach(el => { el.classList.add('st-pre'); io.observe(el); });
  }

  /* Choix de profil, fenêtre et formulaire */
  function initContacts(root, c) {
    const endpoint = root.dataset.endpoint || '';
    let pro = false, kind = 'sav', opener = null;

    /* Deux jeux de 3 cartes : particuliers (data-st-set="part") et professionnels (data-st-set="pro") */
    const setPart = $('[data-st-set="part"]', c), setPro = $('[data-st-set="pro"]', c);
    const announce = $('[data-st-announce]', c), group = $('[data-st-group]', c);
    const FOLD = { transform: 'translateY(-4px) rotateX(-22deg)', opacity: 0, filter: 'brightness(.96)' };
    const OPEN = { transform: 'translateY(0) rotateX(0deg)', opacity: 1, filter: 'brightness(1)' };
    const cards = () => $$('.st-cards:not([hidden]) .st-card', c);
    let running = [], token = 0;

    const setProfile = () => {
      pro = $('input[data-st-profile]:checked', c)?.value === 'pro';
      if (setPart) setPart.hidden = pro;
      if (setPro) setPro.hidden = !pro;
      const key = pro ? 'pro' : 'part';
      group.textContent = group.dataset[key];
      announce.textContent = announce.dataset[key];
    };

    /* Changement de profil : les cartes visibles se replient, puis les 3 nouvelles se déplient l'une après l'autre */
    const switchProfile = () => {
      if (reduce || !c.animate) { setProfile(); return; }
      const id = ++token;
      running.forEach(a => a.cancel());
      const out = cards().map((el, i) => el.animate([OPEN, FOLD], { duration: 160, delay: i * 30, easing: 'cubic-bezier(.5,0,.75,0)', fill: 'forwards' }));
      running = out;
      Promise.all(out.map(a => a.finished)).then(() => {
        if (id !== token) return;
        setProfile();
        out.forEach(a => a.cancel());
        running = cards().map((el, i) => el.animate([FOLD, OPEN], { duration: 380, delay: i * 50, easing: 'cubic-bezier(.22,.7,.2,1)', fill: 'backwards' }));
      }).catch(() => {});
    };
    $$('input[data-st-profile]', c).forEach(r => r.addEventListener('change', switchProfile));
    setProfile();

    const dlg = $('dialog', c);
    if (!dlg) return;
    const form = $('form', dlg), sent = $('[data-st-sent]', dlg), wrap = $('[data-st-formwrap]', dlg);
    const title = $('[data-st-title]', dlg), btn = $('[data-st-submit]', dlg), sendErr = $('[data-st-senderr]', dlg);
    const errSum = $('[data-st-errsum]', dlg);
    const f = n => $(`[data-f="${n}"]`, dlg), e = n => $(`[data-e="${n}"]`, dlg);

    const FIELDS = [
      ['first', 'Prénom : indiquez votre prénom.', el => el.value.trim() !== ''],
      ['last', 'Nom : indiquez votre nom.', el => el.value.trim() !== ''],
      ['email', 'E-mail : indiquez une adresse valide.', el => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(el.value.trim())],
      ['message', 'Message : écrivez votre message.', el => el.value.trim() !== ''],
      ['consent', 'Consentement : cochez la case.', el => el.checked]
    ];

    const clearErrors = () => {
      errSum.hidden = sendErr.hidden = true;
      if (e('file')) e('file').hidden = true;
      FIELDS.forEach(([id]) => { e(id).hidden = true; f(id).removeAttribute('aria-invalid'); });
    };
    FIELDS.forEach(([id]) => {
      const el = f(id);
      el.addEventListener(id === 'consent' ? 'change' : 'input', () => { e(id).hidden = true; el.removeAttribute('aria-invalid'); });
    });
    f('file')?.addEventListener('change', ev => {
      const file = ev.target.files?.[0], tooBig = file && file.size > 5 * 1024 * 1024;
      if (tooBig) ev.target.value = '';
      e('file').hidden = !tooBig;
    });

    const setKind = k => {
      kind = k;
      title.textContent = dlg.dataset['title' + (k === 'sav' ? 'Sav' : 'Pro')];
      $$('[data-for]', dlg).forEach(el => { el.hidden = el.dataset.for !== k; });
      $('[data-st-company]', dlg).hidden = !pro;
      f('type').value = dlg.dataset['type' + (k === 'sav' ? 'Sav' : 'Pro')];
      f('profil').value = pro ? 'Professionnel' : 'Particulier';
    };
    const resetForm = () => {
      form.reset(); clearErrors();
      sent.hidden = true; wrap.hidden = false;
      btn.disabled = false; btn.textContent = btn.dataset.label;
      setKind(kind);
    };
    let closing = null;
    const closeDlg = () => {
      if (!dlg.open || closing) return;
      if (reduce) { dlg.close(); return; }
      dlg.classList.add('st-closing');
      closing = setTimeout(() => { closing = null; dlg.classList.remove('st-closing'); dlg.close(); }, 210);
    };
    const openDialog = () => {
      clearTimeout(closing); closing = null; dlg.classList.remove('st-closing');
      document.documentElement.classList.add('stooly-lock');
      dlg.showModal();
      setTimeout(() => title.focus({ preventScroll: true }), 30);
    };
    const showSuccess = () => {
      wrap.hidden = true; sent.hidden = false;
      title.textContent = dlg.dataset.titleDone;
      sent.focus();
    };

    $$('[data-st-open]', c).forEach(b => b.addEventListener('click', () => {
      opener = b; kind = b.dataset.stOpen; resetForm(); openDialog();
    }));
    $$('[data-st-close]', dlg).forEach(b => b.addEventListener('click', closeDlg));
    $('[data-st-again]', dlg).addEventListener('click', () => { resetForm(); f('first').focus(); });
    dlg.addEventListener('click', ev => { if (ev.target === dlg) closeDlg(); });
    dlg.addEventListener('cancel', ev => { ev.preventDefault(); closeDlg(); });
    dlg.addEventListener('close', () => {
      document.documentElement.classList.remove('stooly-lock');
      opener?.focus();
    });

    form.addEventListener('submit', ev => {
      if (btn.disabled) { ev.preventDefault(); return; }
      clearErrors();
      const bad = FIELDS.filter(([id, , ok]) => !ok(f(id)));
      if (bad.length) {
        ev.preventDefault();
        bad.forEach(([id]) => { e(id).hidden = false; f(id).setAttribute('aria-invalid', 'true'); });
        $('[data-st-errtitle]', dlg).textContent = bad.length === 1 ? 'Un champ est à corriger' : `${bad.length} champs sont à corriger`;
        const list = $('[data-st-errlist]', dlg);
        list.replaceChildren(...bad.map(([id, label]) => {
          const li = document.createElement('li'), a = document.createElement('a');
          a.href = '#'; a.textContent = label;
          a.addEventListener('click', cv => { cv.preventDefault(); f(id).focus(); });
          li.append(a);
          return li;
        }));
        errSum.hidden = false;
        f(bad[0][0]).focus();
        return;
      }
      f('fullname').value = `${f('first').value.trim()} ${f('last').value.trim()}`.trim();
      if (f('hp').value) { ev.preventDefault(); showSuccess(); return; }
      btn.disabled = true; btn.textContent = btn.dataset.sending;
      if (!endpoint) return; /* pas de relais : envoi Shopify natif */
      ev.preventDefault();
      const done = ok => {
        btn.disabled = false; btn.textContent = btn.dataset.label;
        ok ? showSuccess() : (sendErr.hidden = false);
      };
      fetch(endpoint, { method: 'POST', body: new FormData(form) }).then(r => done(r.ok)).catch(() => done(false));
    });

    /* Retour après un envoi Shopify natif */
    if ($('[data-st-posted]', c)) { kind = 'sav'; resetForm(); showSuccess(); openDialog(); }
    else if ($('[data-st-formerror]', c)) {
      kind = 'sav'; resetForm();
      sendErr.textContent = $('[data-st-formerror]', c).textContent;
      sendErr.hidden = false;
      openDialog();
    }
  }

  /* Fiche boutique : « Ouvert maintenant » ou « Fermé · ouvre … », selon l'heure de Paris */
  function initStatus(root) {
    const NAMES = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
    const fmtH = h => h + ' h';
    $$('[data-st-status]', root).forEach(el => {
      const [from, to] = (el.dataset.days || '1-6').split('-').map(Number);
      const open = Number(el.dataset.open), close = Number(el.dataset.close);
      const isDay = d => from <= to ? d >= from && d <= to : d >= from || d <= to;
      const update = () => {
        let day, hour, min;
        try {
          const p = Object.fromEntries(new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Paris', weekday: 'short', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' }).formatToParts(new Date()).map(x => [x.type, x.value]));
          day = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(p.weekday);
          hour = Number(p.hour); min = Number(p.minute);
        } catch (err) { el.hidden = true; return; }
        if (day < 0 || isNaN(hour) || !(close > open)) { el.hidden = true; return; }
        const now = hour + min / 60;
        const openNow = isDay(day) && now >= open && now < close;
        let text;
        if (openNow) {
          text = `Ouvert maintenant · jusqu'à ${fmtH(close)}`;
        } else if (isDay(day) && now < open) {
          text = `Fermé · ouvre aujourd'hui à ${fmtH(open)}`;
        } else {
          let n = 1;
          while (n < 7 && !isDay((day + n) % 7)) n++;
          text = `Fermé · ouvre ${n === 1 ? 'demain' : NAMES[(day + n) % 7]} à ${fmtH(open)}`;
        }
        el.textContent = text;
        el.classList.toggle('st-open', openNow);
        el.hidden = false;
      };
      update();
      setInterval(update, 60000);
    });
  }

  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    root.addEventListener('click', ev => {
      const a = ev.target.closest('[data-st-goto]:not([data-st-spy])');
      if (!a) return;
      ev.preventDefault();
      goTo(a.getAttribute('href').slice(1), a.dataset.stGoto);
    });
    $$('[data-st-goto]:not([data-st-spy])', root).forEach(a => {
      if (!document.getElementById(a.getAttribute('href').slice(1))) a.hidden = true;
    });
    initBar(root);
    initStatus(root);
    initReveal(root);
    initMap(root);
    const c = $('[data-st-contacts]', root);
    if (c) initContacts(root, c);
  }

  const boot = () => $$('.stooly-contact').forEach(init);
  document.addEventListener('shopify:section:load', boot);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stooly-deplier-concept"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('stooly-steps')) return;

    class StoolySteps extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;

        this.items = Array.from(this.track.querySelectorAll('[data-step]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.onDotClick = (event) => {
          this.goTo(Number(event.currentTarget.dataset.dot));
        };
        this.dots.forEach((dot) => dot.addEventListener('click', this.onDotClick));

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) this.setActive(this.items.indexOf(entry.target));
              });
            },
            { root: this.track, threshold: 0.6 }
          );
          this.items.forEach((item) => this.observer.observe(item));
        }

        /* La piste n'est focalisable au clavier que lorsqu'elle défile réellement */
        this.updateFocusable = () => {
          if (this.track.scrollWidth > this.track.clientWidth + 1) {
            this.track.setAttribute('tabindex', '0');
          } else {
            this.track.removeAttribute('tabindex');
          }
        };
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.updateFocusable);
          this.resizeObserver.observe(this.track);
        }
        this.updateFocusable();

        /* Éditeur de thème : amène l'étape sélectionnée à l'écran */
        this.onBlockSelect = (event) => {
          if (!event.detail || event.detail.sectionId !== this.dataset.sectionId) return;
          const index = this.items.findIndex((item) => item.dataset.blockId === event.detail.blockId);
          if (index > -1) this.goTo(index);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        if (this.dots) this.dots.forEach((dot) => dot.removeEventListener('click', this.onDotClick));
        if (this.observer) this.observer.disconnect();
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      goTo(index) {
        const item = this.items[index];
        if (!item) return;
        const padding = parseFloat(getComputedStyle(this.track).scrollPaddingLeft) || 0;
        this.track.scrollTo({
          left: item.offsetLeft - padding,
          behavior: this.reduceMotion.matches ? 'auto' : 'smooth'
        });
        this.setActive(index);
      }

      setActive(index) {
        if (index < 0) return;
        this.dots.forEach((dot, i) => {
          if (i === index) {
            dot.setAttribute('aria-current', 'step');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }
    }

    customElements.define('stooly-steps', StoolySteps);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stooly-meubles-une"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('stooly-featured-products')) return;

  const prefersReducedMotion = () =>
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Normalise un texte pour comparer un nom de variante et un texte alternatif d'image. */
  const normalize = (value) =>
    String(value || '')
      .toLowerCase()
      .replace(/œ/g, 'oe')
      .replace(/æ/g, 'ae')
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

  const parseJson = (element) => {
    if (!element) return [];
    try {
      const data = JSON.parse(element.textContent);
      return Array.isArray(data) ? data : [];
    } catch (error) {
      return [];
    }
  };

  class StoolyFeaturedProducts extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.prevButton = this.querySelector('[data-prev]');
      this.nextButton = this.querySelector('[data-next]');
      this.liveRegion = this.querySelector('[data-live-region]');
      this.dots = this.querySelector('[data-dots]');
      this.dotCount = 0;
      this.timers = new Set();
      this.navFrame = null;
      this.cardData = new WeakMap();

      const d = this.dataset;
      this.text = {
        add: d.textAdd || 'Ajouter au panier',
        adding: d.textAdding || 'Ajout en cours…',
        added: d.textAdded || 'Ajouté au panier',
        soldout: d.textSoldout || 'Épuisé',
        unavailable: d.textUnavailable || 'Indisponible',
        soldoutSuffix: d.textSoldoutSuffix || ' – épuisé',
        error: d.textError || 'Une erreur est survenue. Veuillez réessayer.',
        announce: d.textAnnounce || '[titre] a été ajouté au panier.',
        sale: d.textSale || 'Prix soldé',
        price: d.textPrice || 'Prix',
        dot: d.textDot || 'Aller à la position [n] sur [total]'
      };

      this.onChange = this.onChange.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
      this.onBlockSelect = this.onBlockSelect.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.updateNav = this.updateNav.bind(this);
      this.onPrev = () => this.scrollByPage(-1);
      this.onNext = () => this.scrollByPage(1);
      this.onDotClick = this.onDotClick.bind(this);

      this.addEventListener('change', this.onChange);
      this.addEventListener('submit', this.onSubmit);
      document.addEventListener('shopify:block:select', this.onBlockSelect);

      if (this.prevButton) this.prevButton.addEventListener('click', this.onPrev);
      if (this.nextButton) this.nextButton.addEventListener('click', this.onNext);
      if (this.dots) this.dots.addEventListener('click', this.onDotClick);

      if (this.track) {
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.updateNav);
          this.resizeObserver.observe(this.track);
        }
        this.updateNav();
      }

      this.querySelectorAll('[data-card]').forEach((card) => {
        if (card.querySelector('[data-variants]')) {
          this.refreshAvailability(card, this.getSelection(card));
        }
      });
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
      this.removeEventListener('submit', this.onSubmit);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      if (this.prevButton) this.prevButton.removeEventListener('click', this.onPrev);
      if (this.nextButton) this.nextButton.removeEventListener('click', this.onNext);
      if (this.dots) this.dots.removeEventListener('click', this.onDotClick);
      if (this.track) this.track.removeEventListener('scroll', this.onScroll);
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.navFrame) cancelAnimationFrame(this.navFrame);
      this.timers.forEach((id) => clearTimeout(id));
      this.timers.clear();
    }

    /* ---------- Carrousel ---------- */

    onScroll() {
      if (this.navFrame) return;
      this.navFrame = requestAnimationFrame(() => {
        this.navFrame = null;
        this.updateNav();
      });
    }

    updateNav() {
      if (!this.track) return;
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const scrollable = maxScroll > 2;
      this.dataset.scrollable = String(scrollable);
      if (this.prevButton) this.prevButton.disabled = !scrollable || this.track.scrollLeft <= 2;
      if (this.nextButton) this.nextButton.disabled = !scrollable || this.track.scrollLeft >= maxScroll - 2;
      this.updateDots(maxScroll);
    }

    /* Largeur d'un pas de défilement : une carte + l'espace entre deux cartes. */
    getStep() {
      const item = this.track.querySelector('.stooly-fp__item');
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return item ? item.getBoundingClientRect().width + gap : this.track.clientWidth;
    }

    /* Un repère par position d'arrêt possible ; le repère actif suit le défilement. */
    updateDots(maxScroll) {
      if (!this.dots || !this.track) return;
      const step = this.getStep();
      const count = maxScroll > 2 && step > 0 ? Math.round(maxScroll / step) + 1 : 0;

      if (count !== this.dotCount) {
        this.dotCount = count;
        this.dots.textContent = '';
        for (let i = 0; i < count; i += 1) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'stooly-fp__dot';
          dot.dataset.dotIndex = String(i);
          dot.setAttribute('aria-controls', this.track.id);
          dot.setAttribute(
            'aria-label',
            this.text.dot.replace('[n]', String(i + 1)).replace('[total]', String(count))
          );
          this.dots.appendChild(dot);
        }
      }

      this.dots.hidden = count <= 1;
      if (count <= 1) return;

      const scrollLeft = this.track.scrollLeft;
      const active = maxScroll - scrollLeft <= 2 ? count - 1 : Math.min(count - 1, Math.round(scrollLeft / step));
      this.dots.querySelectorAll('.stooly-fp__dot').forEach((dot, index) => {
        dot.setAttribute('aria-current', index === active ? 'true' : 'false');
      });
    }

    onDotClick(event) {
      const dot = event.target.closest('.stooly-fp__dot');
      if (!dot || !this.track) return;
      const index = Number(dot.dataset.dotIndex) || 0;
      const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      this.track.scrollTo({
        left: Math.min(index * this.getStep(), maxScroll),
        behavior: prefersReducedMotion() ? 'auto' : 'smooth'
      });
    }

    scrollByPage(direction) {
      if (!this.track) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const step = this.getStep();
      const perView = Math.max(1, Math.round((this.track.clientWidth + gap) / step));
      this.track.scrollBy({
        left: direction * step * perView,
        behavior: prefersReducedMotion() ? 'auto' : 'smooth'
      });
    }

    onBlockSelect(event) {
      const detail = event.detail || {};
      if (detail.sectionId !== this.dataset.sectionId || !this.track || !detail.blockId) return;
      const item = this.querySelector('[data-block-id="' + CSS.escape(detail.blockId) + '"]');
      if (!item || this.track.scrollWidth <= this.track.clientWidth) return;
      const paddingLeft = parseFloat(getComputedStyle(this.track).paddingLeft) || 0;
      this.track.scrollTo({
        left: item.offsetLeft - paddingLeft,
        behavior: prefersReducedMotion() ? 'auto' : 'smooth'
      });
    }

    /* ---------- Variantes ---------- */

    onChange(event) {
      const input = event.target;
      if (!input || !input.matches || !input.matches('[data-option-input]')) return;
      const card = input.closest('[data-card]');
      if (card) this.updateCard(card);
    }

    getData(card) {
      if (this.cardData.has(card)) return this.cardData.get(card);
      const img = card.querySelector('[data-primary-image]');
      const data = {
        variants: parseJson(card.querySelector('[data-variants]')),
        images: parseJson(card.querySelector('[data-images]')).map((image) => ({
          ...image,
          key: normalize(image.alt)
        })),
        original: img ? { src: img.getAttribute('src'), srcset: img.getAttribute('srcset') || '' } : null
      };
      this.cardData.set(card, data);
      return data;
    }

    getGroups(card) {
      return Array.from(card.querySelectorAll('[data-option-group]'));
    }

    getSelection(card) {
      return this.getGroups(card).map((group) => {
        if (group.tagName === 'SELECT') return group.value;
        const checked = group.querySelector('[data-option-input]:checked');
        return checked ? checked.value : null;
      });
    }

    /* Signale les valeurs qui ne mènent à aucune variante disponible avec la sélection actuelle. */
    refreshAvailability(card, selection) {
      const { variants } = this.getData(card);
      const isPossible = (index, value) =>
        variants.some(
          (variant) =>
            variant.available &&
            variant.options[index] === value &&
            variant.options.every((optionValue, j) => j === index || selection[j] === null || optionValue === selection[j])
        );

      this.getGroups(card).forEach((group, index) => {
        if (group.tagName === 'SELECT') {
          Array.from(group.options).forEach((option) => {
            const label = option.dataset.label || option.value;
            option.textContent = isPossible(index, option.value) ? label : label + this.text.soldoutSuffix;
          });
          return;
        }

        group.querySelectorAll('[data-option-input]').forEach((input) => {
          const possible = isPossible(index, input.value);
          const label = card.querySelector('label[for="' + CSS.escape(input.id) + '"]');
          if (!label) return;
          label.classList.toggle('is-unavailable', !possible);
          const note = label.querySelector('[data-unavailable-note]');
          if (note) note.hidden = possible;
        });
      });
    }

    /* Image : visuel de la variante, sinon visuel dont le texte alternatif contient une valeur choisie. */
    findImage(card, variant, selection) {
      if (variant && variant.src) return { src: variant.src, srcset: variant.srcset || '' };
      const { images } = this.getData(card);
      if (!images.length) return null;

      const groups = this.getGroups(card);
      const ordered = selection
        .map((value, index) => ({ value, isColor: groups[index] && groups[index].tagName !== 'SELECT' }))
        .filter((entry) => entry.value)
        .sort((a, b) => Number(b.isColor) - Number(a.isColor));

      for (const entry of ordered) {
        const key = normalize(entry.value);
        if (!key) continue;
        const match = images.find((image) => image.key && image.key.indexOf(key) !== -1);
        if (match) return { src: match.src, srcset: match.srcset || '' };
      }
      return null;
    }

    setImage(card, image) {
      const img = card.querySelector('[data-primary-image]');
      if (!img) return;
      const { original } = this.getData(card);
      const target = image || original;
      if (!target || !target.src) return;
      if (img.getAttribute('src') !== target.src) {
        if (target.srcset) {
          img.setAttribute('srcset', target.srcset);
        } else {
          img.removeAttribute('srcset');
        }
        img.setAttribute('src', target.src);
      }
      card.classList.toggle('has-variant-image', Boolean(image));
    }

    updateCard(card) {
      const selection = this.getSelection(card);
      const { variants } = this.getData(card);
      const variant =
        variants.find(
          (item) =>
            Array.isArray(item.options) &&
            item.options.length === selection.length &&
            item.options.every((value, index) => value === selection[index])
        ) || null;

      this.refreshAvailability(card, selection);

      let tint = '';
      this.getGroups(card).forEach((group) => {
        if (group.tagName === 'SELECT') return;
        const checked = group.querySelector('[data-option-input]:checked');
        if (!checked) return;
        if (checked.dataset.tint) tint = checked.dataset.tint;
        const valueLabel = group.querySelector('[data-option-value]');
        if (valueLabel) valueLabel.textContent = checked.value;
      });
      if (tint) {
        card.style.setProperty('--stooly-media-bg', tint);
      } else {
        card.style.removeProperty('--stooly-media-bg');
      }

      this.setImage(card, this.findImage(card, variant, selection));

      const button = card.querySelector('[data-add-button]');
      const busy = button && button.getAttribute('aria-busy') === 'true';

      if (!variant) {
        if (button && !busy) {
          button.disabled = true;
          button.dataset.state = 'unavailable';
          this.setButtonState(button, 'idle');
        }
        return;
      }

      const idField = card.querySelector('[data-variant-id]');
      if (idField) idField.value = String(variant.id);

      const price = card.querySelector('[data-price]');
      if (price && variant.price) price.textContent = variant.price;

      const compareWrap = card.querySelector('[data-compare-wrap]');
      const compare = card.querySelector('[data-compare]');
      if (compareWrap && compare) {
        compare.textContent = variant.compare || '';
        compareWrap.hidden = !variant.compare;
      }

      const priceLabel = card.querySelector('[data-price-label]');
      if (priceLabel) priceLabel.textContent = variant.compare ? this.text.sale : this.text.price;

      const saleBadge = card.querySelector('[data-sale-badge]');
      if (saleBadge) {
        saleBadge.textContent = variant.sale || '';
        saleBadge.hidden = !variant.sale;
      }

      if (button && !busy) {
        button.disabled = !variant.available;
        button.dataset.state = variant.available ? 'available' : 'soldout';
        this.setButtonState(button, 'idle');
      }
    }

    /* ---------- Ajout au panier ---------- */

    async onSubmit(event) {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.classList.contains('stooly-card__form')) return;
      event.preventDefault();

      const button = form.querySelector('[data-add-button]');
      const idField = form.querySelector('[name="id"]');
      if (!button || !idField || button.disabled || button.getAttribute('aria-busy') === 'true') return;

      const card = form.closest('[data-card]');
      const errorEl = card ? card.querySelector('[data-error]') : null;
      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }

      this.setButtonState(button, 'loading');

      try {
        const response = await fetch(this.dataset.cartAddUrl + '.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ items: [{ id: Number(idField.value), quantity: 1 }] })
        });
        const data = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(data.description || data.message || this.text.error);

        this.setButtonState(button, 'added');
        const title = button.dataset.productTitle || '';
        this.announce(this.text.announce.replace('[titre]', title));
        this.notifyTheme(data);
      } catch (error) {
        this.setButtonState(button, 'idle');
        const message = (error && error.message) || this.text.error;
        if (errorEl) {
          errorEl.textContent = message;
          errorEl.hidden = false;
        }
        this.announce(message);
      }
    }

    setButtonState(button, state) {
      const label = button.querySelector('[data-add-label]');
      if (button._stoolyTimer) {
        clearTimeout(button._stoolyTimer);
        this.timers.delete(button._stoolyTimer);
        button._stoolyTimer = null;
      }
      button.classList.remove('is-loading', 'is-added');

      if (state === 'loading') {
        button.classList.add('is-loading');
        button.setAttribute('aria-busy', 'true');
        if (label) label.textContent = this.text.adding;
        return;
      }

      button.removeAttribute('aria-busy');

      if (state === 'added') {
        button.classList.add('is-added');
        if (label) label.textContent = this.text.added;
        const timer = setTimeout(() => {
          this.timers.delete(timer);
          button._stoolyTimer = null;
          this.setButtonState(button, 'idle');
        }, 2500);
        button._stoolyTimer = timer;
        this.timers.add(timer);
        return;
      }

      let idleText = this.text.add;
      if (button.dataset.state === 'unavailable') {
        idleText = this.text.unavailable;
      } else if (button.disabled) {
        idleText = this.text.soldout;
      }
      if (label) label.textContent = idleText;
    }

    announce(message) {
      if (!this.liveRegion) return;
      this.liveRegion.textContent = '';
      const timer = setTimeout(() => {
        this.timers.delete(timer);
        this.liveRegion.textContent = message;
      }, 60);
      this.timers.add(timer);
    }

    /* Point d'intégration avec le tiroir panier / compteur du thème (à confirmer pour Impact). */
    notifyTheme(added) {
      document.dispatchEvent(
        new CustomEvent('stooly:cart:added', { detail: { items: (added && added.items) || [] } })
      );

      fetch(this.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' } })
        .then((response) => response.json())
        .then((cart) => {
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:refresh', { bubbles: true, detail: { cart } })
          );
          document.dispatchEvent(new CustomEvent('stooly:cart:updated', { detail: { cart } }));
        })
        .catch(() => {});
    }
  }

  customElements.define('stooly-featured-products', StoolyFeaturedProducts);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stooly-popup-video"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('stooly-video-popup')) return;

    const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const LOCK_CLASS = 'svp-scroll-lock';
    const IFRAME_ALLOW =
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen; web-share';

    const EMBEDS = {
      youtube: (id, autoplay) =>
        `https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?rel=0&playsinline=1&autoplay=${autoplay ? 1 : 0}`,
      vimeo: (id, autoplay) =>
        `https://player.vimeo.com/video/${encodeURIComponent(id)}?dnt=1&autoplay=${autoplay ? 1 : 0}`
    };

    class StoolyVideoPopup extends HTMLElement {
      constructor() {
        super();
        this.lastTrigger = null;
        this.closing = false;
        this.ambientInView = false;
        this.ambientUserChoice = null;

        this.onOpenClick = this.onOpenClick.bind(this);
        this.onCoverClick = this.onCoverClick.bind(this);
        this.onCloseClick = this.onCloseClick.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.onDialogClick = this.onDialogClick.bind(this);
        this.onDialogClose = this.onDialogClose.bind(this);
        this.onSectionDeselect = this.onSectionDeselect.bind(this);
        this.onMotionChange = this.onMotionChange.bind(this);
        this.onAmbientToggle = this.onAmbientToggle.bind(this);
        this.onAmbientPlaying = this.onAmbientPlaying.bind(this);
      }

      connectedCallback() {
        this.dialog = this.querySelector('[data-svp-dialog]');
        this.player = this.querySelector('[data-svp-player]');
        this.template = this.querySelector('[data-svp-template]');
        this.cover = this.querySelector('[data-svp-cover]');
        this.closeButton = this.querySelector('[data-svp-close]');
        this.ambient = this.querySelector('[data-svp-ambient]');
        this.ambientToggle = this.querySelector('[data-svp-ambient-toggle]');
        this.openButtons = Array.from(this.querySelectorAll('[data-svp-open]'));

        this.openButtons.forEach((button) => button.addEventListener('click', this.onOpenClick));

        if (this.cover && this.openButtons.length && this.dialog) {
          this.cover.addEventListener('click', this.onCoverClick);
        }

        if (this.dialog) {
          this.dialog.addEventListener('cancel', this.onCancel);
          this.dialog.addEventListener('click', this.onDialogClick);
          this.dialog.addEventListener('close', this.onDialogClose);
        }

        if (this.closeButton) this.closeButton.addEventListener('click', this.onCloseClick);

        document.addEventListener('shopify:section:deselect', this.onSectionDeselect);

        if (motionQuery.addEventListener) {
          motionQuery.addEventListener('change', this.onMotionChange);
        }

        this.setupAmbient();
      }

      disconnectedCallback() {
        this.openButtons.forEach((button) => button.removeEventListener('click', this.onOpenClick));
        if (this.cover) this.cover.removeEventListener('click', this.onCoverClick);

        if (this.dialog) {
          this.dialog.removeEventListener('cancel', this.onCancel);
          this.dialog.removeEventListener('click', this.onDialogClick);
          this.dialog.removeEventListener('close', this.onDialogClose);
        }

        if (this.closeButton) this.closeButton.removeEventListener('click', this.onCloseClick);
        if (this.ambientToggle) this.ambientToggle.removeEventListener('click', this.onAmbientToggle);
        if (this.ambient) this.ambient.removeEventListener('playing', this.onAmbientPlaying);

        document.removeEventListener('shopify:section:deselect', this.onSectionDeselect);

        if (motionQuery.removeEventListener) {
          motionQuery.removeEventListener('change', this.onMotionChange);
        }

        if (this.observer) {
          this.observer.disconnect();
          this.observer = null;
        }

        this.forceClose();
      }

      /* Ouverture / fermeture */

      onOpenClick(event) {
        this.open(event.currentTarget);
      }

      onCoverClick(event) {
        if (event.target.closest('a, button, input, select, textarea')) return;
        this.open(this.openButtons[0]);
      }

      onCloseClick() {
        this.close();
      }

      onCancel(event) {
        event.preventDefault();
        this.close();
      }

      onDialogClick(event) {
        if (event.target === this.dialog) this.close();
      }

      onSectionDeselect(event) {
        if (event.detail && event.detail.sectionId === this.dataset.sectionId) {
          this.forceClose();
        }
      }

      open(trigger) {
        if (!this.dialog || this.dialog.open || typeof this.dialog.showModal !== 'function') return;

        this.lastTrigger = trigger || document.activeElement;
        this.mountPlayer();
        this.dialog.showModal();
        document.documentElement.classList.add(LOCK_CLASS);
        this.updateAmbient();

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            if (this.dialog && this.dialog.open) this.dialog.classList.add('is-visible');
          });
        });
      }

      close() {
        if (!this.dialog || !this.dialog.open || this.closing) return;

        if (motionQuery.matches) {
          this.dialog.close();
          return;
        }

        this.closing = true;
        this.dialog.classList.remove('is-visible');

        const inner = this.dialog.querySelector('.svp-dialog__inner');
        let done = false;
        const finish = () => {
          if (done) return;
          done = true;
          this.closing = false;
          if (this.dialog && this.dialog.open) this.dialog.close();
        };

        if (inner) inner.addEventListener('transitionend', finish, { once: true });
        window.setTimeout(finish, 450);
      }

      forceClose() {
        this.closing = false;
        if (this.dialog) {
          this.dialog.classList.remove('is-visible');
          if (this.dialog.open) this.dialog.close();
        }
        this.unmountPlayer();
        document.documentElement.classList.remove(LOCK_CLASS);
      }

      onDialogClose() {
        this.closing = false;
        this.dialog.classList.remove('is-visible');
        this.unmountPlayer();
        document.documentElement.classList.remove(LOCK_CLASS);

        if (this.isConnected && this.lastTrigger && typeof this.lastTrigger.focus === 'function') {
          this.lastTrigger.focus({ preventScroll: true });
        }

        this.updateAmbient();
      }

      /* Lecteur */

      mountPlayer() {
        if (!this.player) return;

        const type = this.dataset.videoType;
        const id = this.dataset.videoId;
        const autoplay = this.dataset.autoplay === 'true';

        this.unmountPlayer();

        if (type === 'local' && this.template) {
          const fragment = this.template.content.cloneNode(true);
          const video = fragment.querySelector('video');
          this.player.appendChild(fragment);

          if (video) {
            video.addEventListener('loadeddata', () => this.player.classList.add('is-loaded'), { once: true });
            if (autoplay) {
              const playPromise = video.play();
              if (playPromise) playPromise.catch(() => {});
            }
          }
          return;
        }

        if (EMBEDS[type] && id) {
          const iframe = document.createElement('iframe');
          iframe.src = EMBEDS[type](id, autoplay);
          iframe.title = this.dataset.videoTitle || '';
          iframe.allow = IFRAME_ALLOW;
          iframe.allowFullscreen = true;
          iframe.referrerPolicy = 'strict-origin-when-cross-origin';
          iframe.addEventListener('load', () => this.player.classList.add('is-loaded'), { once: true });
          this.player.appendChild(iframe);
        }
      }

      unmountPlayer() {
        if (!this.player) return;
        const video = this.player.querySelector('video');
        if (video) video.pause();
        this.player.replaceChildren();
        this.player.classList.remove('is-loaded');
      }

      /* Aperçu animé en arrière-plan */

      setupAmbient() {
        if (!this.ambient) return;

        this.ambient.muted = true;
        this.ambient.addEventListener('playing', this.onAmbientPlaying);

        if (this.ambientToggle) this.ambientToggle.addEventListener('click', this.onAmbientToggle);

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              this.ambientInView = entries[0].isIntersecting;
              this.updateAmbient();
            },
            { threshold: 0.2 }
          );
          this.observer.observe(this);
        } else {
          this.ambientInView = true;
          this.updateAmbient();
        }
      }

      onAmbientPlaying() {
        this.ambient.classList.add('is-playing');
      }

      onAmbientToggle() {
        this.ambientUserChoice = this.ambientWanted() ? 'pause' : 'play';
        this.updateAmbient();
      }

      onMotionChange() {
        this.updateAmbient();
      }

      ambientWanted() {
        if (this.ambientUserChoice === 'play') return true;
        if (this.ambientUserChoice === 'pause') return false;
        return !motionQuery.matches;
      }

      updateAmbient() {
        if (!this.ambient) return;

        const wanted = this.ambientWanted();
        const dialogOpen = Boolean(this.dialog && this.dialog.open);

        if (wanted && this.ambientInView && !dialogOpen) {
          const playPromise = this.ambient.play();
          if (playPromise) playPromise.catch(() => {});
        } else {
          this.ambient.pause();
        }

        if (this.ambientToggle) {
          this.ambientToggle.dataset.state = wanted ? 'playing' : 'paused';
          this.ambientToggle.setAttribute(
            'aria-label',
            wanted ? this.ambientToggle.dataset.labelPause : this.ambientToggle.dataset.labelPlay
          );
        }
      }
    }

    customElements.define('stooly-video-popup', StoolyVideoPopup);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stooly-reassurance-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('stooly-reassurance-bar')) return;

    const DRAG_THRESHOLD = 6;
    const RESUME_DELAY = 1500;
    const MAX_VELOCITY = 3000;

    const addMqListener = (mq, fn) => {
      if (mq.addEventListener) mq.addEventListener('change', fn);
      else if (mq.addListener) mq.addListener(fn);
    };
    const removeMqListener = (mq, fn) => {
      if (mq.removeEventListener) mq.removeEventListener('change', fn);
      else if (mq.removeListener) mq.removeListener(fn);
    };
    const isDisplayed = (el) => window.getComputedStyle(el).display !== 'none';
    const isFocusVisible = (el) => {
      try {
        return el.matches(':focus-visible');
      } catch (error) {
        return true;
      }
    };

    class StoolyReassuranceBar extends HTMLElement {
      constructor() {
        super();
        this.frame = null;
        this.rafId = null;
        this.lastWidth = 0;
        this.lastTime = 0;
        this.editorStatic = false;
        this.userPaused = false;
        this.hovered = false;
        this.focused = false;
        this.offset = 0;
        this.distance = 0;
        this.speed = 0;
        this.velocity = 0;
        this.resumeAt = 0;
        this.drag = null;
        this.suppressClick = false;
        this.mediaQueries = [];

        this.scheduleUpdate = this.scheduleUpdate.bind(this);
        this.tick = this.tick.bind(this);
        this.onBlockSelect = this.onBlockSelect.bind(this);
        this.onBlockDeselect = this.onBlockDeselect.bind(this);
        this.onToggle = this.onToggle.bind(this);
        this.onPointerDown = this.onPointerDown.bind(this);
        this.onPointerMove = this.onPointerMove.bind(this);
        this.onPointerUp = this.onPointerUp.bind(this);
        this.onPointerEnter = this.onPointerEnter.bind(this);
        this.onPointerLeave = this.onPointerLeave.bind(this);
        this.onFocusIn = this.onFocusIn.bind(this);
        this.onFocusOut = this.onFocusOut.bind(this);
        this.onClickCapture = this.onClickCapture.bind(this);
        this.onDragStart = this.onDragStart.bind(this);
      }

      connectedCallback() {
        this.viewport = this.querySelector('.stooly-bar__viewport');
        this.wrapper = this.querySelector('.stooly-bar__wrapper');
        if (!this.viewport || !this.wrapper) return;

        const breakpoint = parseInt(this.dataset.breakpoint, 10) || 1024;
        this.mqMobile = window.matchMedia('(max-width: ' + breakpoint + 'px)');
        this.mqReduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.mqSmall = window.matchMedia('(max-width: 767px)');
        this.mediaQueries = [this.mqMobile, this.mqReduced, this.mqSmall];
        this.mediaQueries.forEach((mq) => addMqListener(mq, this.scheduleUpdate));

        this.toggleButton = this.querySelector('.stooly-bar__toggle');
        if (this.toggleButton) this.toggleButton.addEventListener('click', this.onToggle);

        this.viewport.addEventListener('pointerdown', this.onPointerDown);
        this.viewport.addEventListener('pointermove', this.onPointerMove);
        this.viewport.addEventListener('pointerup', this.onPointerUp);
        this.viewport.addEventListener('pointercancel', this.onPointerUp);
        this.viewport.addEventListener('pointerenter', this.onPointerEnter);
        this.viewport.addEventListener('pointerleave', this.onPointerLeave);
        this.viewport.addEventListener('click', this.onClickCapture, true);
        this.viewport.addEventListener('dragstart', this.onDragStart);
        this.addEventListener('focusin', this.onFocusIn);
        this.addEventListener('focusout', this.onFocusOut);

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver((entries) => {
            const width = Math.round(entries[0].contentRect.width);
            if (width !== this.lastWidth) this.scheduleUpdate();
          });
          this.resizeObserver.observe(this);
        } else {
          window.addEventListener('resize', this.scheduleUpdate);
        }

        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);

        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(() => {
            if (this.isConnected) this.scheduleUpdate();
          });
        }

        this.update();
      }

      disconnectedCallback() {
        if (this.frame) cancelAnimationFrame(this.frame);
        this.stopLoop();
        this.mediaQueries.forEach((mq) => removeMqListener(mq, this.scheduleUpdate));
        if (this.resizeObserver) this.resizeObserver.disconnect();
        window.removeEventListener('resize', this.scheduleUpdate);
        if (this.toggleButton) this.toggleButton.removeEventListener('click', this.onToggle);
        if (this.viewport) {
          this.viewport.removeEventListener('pointerdown', this.onPointerDown);
          this.viewport.removeEventListener('pointermove', this.onPointerMove);
          this.viewport.removeEventListener('pointerup', this.onPointerUp);
          this.viewport.removeEventListener('pointercancel', this.onPointerUp);
          this.viewport.removeEventListener('pointerenter', this.onPointerEnter);
          this.viewport.removeEventListener('pointerleave', this.onPointerLeave);
          this.viewport.removeEventListener('click', this.onClickCapture, true);
          this.viewport.removeEventListener('dragstart', this.onDragStart);
        }
        this.removeEventListener('focusin', this.onFocusIn);
        this.removeEventListener('focusout', this.onFocusOut);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      scheduleUpdate() {
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      }

      setMode(mode) {
        if (mode) this.dataset.mode = mode;
        else delete this.dataset.mode;
      }

      removeClones() {
        this.wrapper.querySelectorAll(':scope > [data-stooly-clone]').forEach((node) => node.remove());
      }

      appendClones(originals) {
        const fragment = document.createDocumentFragment();
        originals.forEach((node) => {
          const clone = node.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.setAttribute('inert', '');
          clone.setAttribute('data-stooly-clone', '');
          clone.removeAttribute('data-shopify-editor-block');
          clone.querySelectorAll('a, button, [tabindex]').forEach((el) => el.setAttribute('tabindex', '-1'));
          clone.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
          fragment.appendChild(clone);
        });
        this.wrapper.appendChild(fragment);
      }

      update() {
        if (!this.isConnected || !this.wrapper) return;

        this.stopLoop();
        this.drag = null;
        this.velocity = 0;
        this.removeAttribute('data-dragging');
        this.wrapper.style.removeProperty('transform');
        this.removeClones();

        const originals = Array.from(this.wrapper.children);
        const firstVisible = originals.findIndex(isDisplayed);

        // Every block is hidden on this screen size: hide the empty bar.
        if (firstVisible === -1) {
          this.toggleAttribute('data-empty', true);
          this.setMode('static');
          this.lastWidth = 0;
          return;
        }
        this.removeAttribute('data-empty');
        this.lastWidth = Math.round(this.clientWidth);

        // Desktop: keep the static single line when everything fits.
        if (!this.mqMobile.matches) {
          this.setMode('static');
          if (this.wrapper.scrollWidth <= this.wrapper.clientWidth + 1) return;
        }

        // Reduced motion or block selected in the editor: show every item without motion.
        if (this.mqReduced.matches || this.editorStatic) {
          this.setMode('wrap');
          return;
        }

        // Compact single-line layout (pause button hidden) to measure the real content width.
        this.setMode('measure');
        const available = this.viewport.clientWidth;
        if (this.wrapper.offsetWidth <= available) {
          this.setMode('wrap');
          return;
        }

        this.appendClones(originals);
        const cloneOfFirst = this.wrapper.children[originals.length + firstVisible];
        const distance = cloneOfFirst ? cloneOfFirst.offsetLeft - originals[firstVisible].offsetLeft : 0;

        if (distance <= 0) {
          this.removeClones();
          this.setMode('wrap');
          return;
        }

        const totalSets = Math.ceil(available / distance) + 1;
        for (let i = 2; i < totalSets; i += 1) this.appendClones(originals);

        const duration = parseFloat(this.dataset.duration) || 30;
        this.distance = distance;
        this.speed = distance / duration;
        this.offset = this.normalize(this.offset);
        this.setMode('marquee');
        this.render();
        this.startLoop();
      }

      // Keeps the offset within one set width so the loop never shows a gap.
      normalize(value) {
        if (!this.distance) return 0;
        let result = value % this.distance;
        if (result > 0) result -= this.distance;
        return result;
      }

      render() {
        this.wrapper.style.transform = 'translate3d(' + this.offset.toFixed(2) + 'px, 0, 0)';
      }

      isPaused() {
        return this.userPaused || this.hovered || this.focused;
      }

      startLoop() {
        this.stopLoop();
        this.lastTime = 0;
        this.rafId = requestAnimationFrame(this.tick);
      }

      stopLoop() {
        if (this.rafId) cancelAnimationFrame(this.rafId);
        this.rafId = null;
      }

      tick(now) {
        this.rafId = requestAnimationFrame(this.tick);
        const dt = this.lastTime ? Math.min((now - this.lastTime) / 1000, 0.05) : 0;
        this.lastTime = now;

        if (this.drag && this.drag.active) return;

        if (Math.abs(this.velocity) > 5) {
          // Inertia after a swipe, slowing down smoothly.
          this.offset += this.velocity * dt;
          this.velocity *= Math.pow(0.04, dt);
        } else {
          this.velocity = 0;
          if (!this.isPaused() && now >= this.resumeAt) this.offset -= this.speed * dt;
        }

        this.offset = this.normalize(this.offset);
        this.render();
      }

      onPointerDown(event) {
        this.suppressClick = false;
        if (this.dataset.mode !== 'marquee') return;
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        this.velocity = 0;
        this.drag = {
          id: event.pointerId,
          startX: event.clientX,
          startOffset: this.offset,
          lastX: event.clientX,
          lastT: event.timeStamp,
          active: false
        };
      }

      onPointerMove(event) {
        const drag = this.drag;
        if (!drag || event.pointerId !== drag.id) return;
        const dx = event.clientX - drag.startX;

        if (!drag.active) {
          if (Math.abs(dx) < DRAG_THRESHOLD) return;
          drag.active = true;
          this.setAttribute('data-dragging', '');
          try {
            this.viewport.setPointerCapture(event.pointerId);
          } catch (error) {
            /* Pointer capture is optional. */
          }
        }

        const dt = event.timeStamp - drag.lastT;
        if (dt > 0) {
          const velocity = ((event.clientX - drag.lastX) / dt) * 1000;
          this.velocity = Math.max(-MAX_VELOCITY, Math.min(MAX_VELOCITY, velocity));
        }
        drag.lastX = event.clientX;
        drag.lastT = event.timeStamp;

        this.offset = this.normalize(drag.startOffset + dx);
        this.render();
      }

      onPointerUp(event) {
        const drag = this.drag;
        if (!drag || event.pointerId !== drag.id) return;

        if (drag.active) {
          this.suppressClick = true;
          this.resumeAt = performance.now() + RESUME_DELAY;
          if (event.type === 'pointercancel' || event.timeStamp - drag.lastT > 100) this.velocity = 0;
          this.removeAttribute('data-dragging');
          try {
            this.viewport.releasePointerCapture(event.pointerId);
          } catch (error) {
            /* Already released. */
          }
        } else {
          this.velocity = 0;
        }

        this.drag = null;
      }

      onPointerEnter(event) {
        if (event.pointerType === 'mouse') this.hovered = true;
      }

      onPointerLeave(event) {
        if (event.pointerType === 'mouse') this.hovered = false;
      }

      onFocusIn(event) {
        this.focused = isFocusVisible(event.target);
      }

      onFocusOut(event) {
        if (!event.relatedTarget || !this.contains(event.relatedTarget)) this.focused = false;
      }

      // A swipe must not open the link it started on.
      onClickCapture(event) {
        if (!this.suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
        this.suppressClick = false;
      }

      onDragStart(event) {
        if (this.dataset.mode === 'marquee') event.preventDefault();
      }

      onToggle() {
        this.userPaused = !this.userPaused;
        this.toggleAttribute('data-paused', this.userPaused);
        this.toggleButton.setAttribute('aria-pressed', String(this.userPaused));
      }

      isOwnEvent(event) {
        return Boolean(event.detail && event.detail.sectionId === this.dataset.sectionId);
      }

      onBlockSelect(event) {
        if (!this.isOwnEvent(event)) return;
        this.editorStatic = true;
        this.update();
      }

      onBlockDeselect(event) {
        if (!this.isOwnEvent(event)) return;
        this.editorStatic = false;
        this.update();
      }
    }

    customElements.define('stooly-reassurance-bar', StoolyReassuranceBar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stooly-slideshow"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (!window.customElements || customElements.get('stooly-slideshow')) return;

    const SWIPE_THRESHOLD = 50;

    class StoolySlideshow extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-ssp-slide]')];
        if (!this.slides.length) return;

        this.track = this.querySelector('[data-ssp-track]');
        this.dots = [...this.querySelectorAll('[data-ssp-dot]')];
        this.toggle = this.querySelector('[data-ssp-toggle]');
        this.videos = [...this.querySelectorAll('video')];
        this.delay = (parseInt(this.dataset.autoplay, 10) || 0) * 1000;
        this.waitVideo = this.dataset.waitVideo === 'true';
        this.blocked = new WeakSet();

        const reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.state = { user: reduced.matches, hover: false, focus: false, editor: false, offscreen: false };
        this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-selected')));

        this.controller = new AbortController();
        const { signal } = this.controller;
        const on = (target, type, handler, extra = {}) => {
          if (target) target.addEventListener(type, handler, { signal, ...extra });
        };

        on(this.querySelector('[data-ssp-prev]'), 'click', () => this.goTo(this.index - 1));
        on(this.querySelector('[data-ssp-next]'), 'click', () => this.goTo(this.index + 1));
        this.dots.forEach((dot) => on(dot, 'click', () => this.goTo(Number(dot.dataset.sspDot))));
        on(this.toggle, 'click', () => this.set('user', !this.state.user));

        on(this, 'keydown', (event) => this.onKeydown(event));
        on(this, 'pointerenter', (event) => { if (event.pointerType === 'mouse') this.set('hover', true); });
        on(this, 'pointerleave', (event) => { if (event.pointerType === 'mouse') this.set('hover', false); });
        on(this, 'focusin', () => this.set('focus', true));
        on(this, 'focusout', (event) => { if (!this.contains(event.relatedTarget)) this.set('focus', false); });

        this.videos.forEach((video) => {
          on(video, 'ended', () => this.onVideoEnded(video));
          // capture : les erreurs des balises <source> ne remontent pas jusqu'à <video>
          on(video, 'error', () => { this.blocked.add(video); this.schedule(); }, { capture: true });
        });

        on(document, 'visibilitychange', () => this.update());
        on(matchMedia('(min-width: 700px)'), 'change', () => this.update());
        on(reduced, 'change', (event) => this.set('user', event.matches));

        this.bindSwipe(on);
        if (window.Shopify && Shopify.designMode) this.bindThemeEditor(on);

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            this.set('offscreen', !entries[entries.length - 1].isIntersecting);
          }, { threshold: 0.1 });
          this.observer.observe(this);
        }

        this.goTo(this.index);
      }

      disconnectedCallback() {
        if (this.controller) this.controller.abort();
        if (this.observer) this.observer.disconnect();
        clearTimeout(this.timer);
        if (this.videos) this.videos.forEach((video) => video.pause());
      }

      set(key, value) {
        if (this.state[key] === value) return;
        this.state[key] = value;
        this.update();
      }

      bindSwipe(on) {
        if (!this.track || this.slides.length < 2) return;
        let start = null;
        let suppressClick = false;

        on(this.track, 'pointerdown', (event) => {
          start = event.pointerType === 'mouse' ? null : { x: event.clientX, y: event.clientY };
        });
        on(this.track, 'pointercancel', () => { start = null; });
        on(this.track, 'pointerup', (event) => {
          if (!start) return;
          const dx = event.clientX - start.x;
          const dy = event.clientY - start.y;
          start = null;
          if (Math.abs(dx) <= SWIPE_THRESHOLD || Math.abs(dx) <= Math.abs(dy)) return;

          suppressClick = true;
          setTimeout(() => { suppressClick = false; }, 400);
          this.goTo(this.index + (dx < 0 ? 1 : -1));
        });
        on(this.track, 'click', (event) => {
          if (!suppressClick) return;
          event.preventDefault();
          event.stopPropagation();
        }, { capture: true });
      }

      bindThemeEditor(on) {
        const isOwn = (event) => event.detail && event.detail.sectionId === this.dataset.sectionId;

        on(document, 'shopify:section:select', (event) => { if (isOwn(event)) this.set('editor', true); });
        on(document, 'shopify:section:deselect', (event) => { if (isOwn(event)) this.set('editor', false); });
        on(document, 'shopify:block:deselect', (event) => { if (isOwn(event)) this.set('editor', false); });
        on(document, 'shopify:block:select', (event) => {
          if (!isOwn(event)) return;
          this.state.editor = true;
          const target = this.slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
          if (target >= 0) this.goTo(target);
          else this.update();
        });
      }

      onKeydown(event) {
        if (this.slides.length < 2 || !event.target.closest('[data-ssp-controls]')) return;
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.goTo(this.index + (event.key === 'ArrowRight' ? 1 : -1));
      }

      goTo(target) {
        const count = this.slides.length;
        const next = ((target % count) + count) % count;
        const changed = next !== this.index;

        if (changed) this.classList.add('ssp--animate');

        this.slides.forEach((slide, i) => {
          const active = i === next;
          slide.classList.toggle('is-selected', active);
          slide.toggleAttribute('inert', !active);
          if (active) slide.removeAttribute('aria-hidden');
          else slide.setAttribute('aria-hidden', 'true');
        });

        this.dots.forEach((dot, i) => {
          if (i === next) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });

        if (changed && this.delay && this.waitVideo) {
          this.slides[next].querySelectorAll('video').forEach((video) => {
            try { video.currentTime = 0; } catch (error) { /* vidéo pas encore chargée */ }
          });
        }

        this.index = next;
        this.update();
      }

      mediaAllowed() {
        return !this.state.user && !this.state.offscreen && !document.hidden;
      }

      canAdvance() {
        const { hover, focus, editor } = this.state;
        return this.delay > 0 && this.slides.length > 1 && this.mediaAllowed() && !hover && !focus && !editor;
      }

      update() {
        this.dataset.paused = String(this.state.user);

        if (this.toggle) {
          const { labelPlay, labelPause } = this.toggle.dataset;
          this.toggle.setAttribute('aria-label', this.state.user ? labelPlay : labelPause);
        }

        if (this.track) this.track.setAttribute('aria-live', this.canAdvance() ? 'off' : 'polite');

        this.syncVideos();
        this.schedule();
      }

      isRendered(element) {
        return element.getClientRects().length > 0;
      }

      activeVideo() {
        return [...this.slides[this.index].querySelectorAll('video')].find((video) => this.isRendered(video)) || null;
      }

      syncVideos() {
        const allowed = this.mediaAllowed();
        const current = this.slides[this.index];

        this.videos.forEach((video) => {
          if (allowed && current.contains(video) && this.isRendered(video)) this.play(video);
          else if (!video.paused) video.pause();
        });
      }

      play(video) {
        if (!video.paused) return;

        video.muted = true;
        video.playsInline = true;
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        if (video.preload === 'none') video.preload = 'auto';

        const attempt = video.play();
        if (attempt && attempt.then) {
          attempt
            .then(() => this.blocked.delete(video))
            .catch(() => {
              // Lecture automatique refusée (ex. mode économie d'énergie) : l'image d'aperçu reste affichée.
              this.blocked.add(video);
              this.schedule();
            });
        }
      }

      onVideoEnded(video) {
        if (!this.slides[this.index].contains(video)) return;

        if (this.canAdvance()) {
          this.goTo(this.index + 1);
        } else if (this.mediaAllowed()) {
          try { video.currentTime = 0; } catch (error) { /* ignoré */ }
          this.play(video);
        }
      }

      schedule() {
        clearTimeout(this.timer);
        if (!this.canAdvance()) return;

        const video = this.activeVideo();
        if (video && this.waitVideo && !this.blocked.has(video)) return;

        this.timer = setTimeout(() => this.goTo(this.index + 1), this.delay);
      }
    }

    customElements.define('stooly-slideshow', StoolySlideshow);
  })();

  } catch(e) { console.error(e); }
})();
})();
